import { useEffect, useRef, type RefObject } from "react";

import type { Game } from "src/api";

import { AllPieceScene } from "./AllPiecesScene";

export function useAllPiecesScene(
  host: RefObject<HTMLElement | null>,
  background: string,
  game: Game,
) {
  const sceneRef = useRef<AllPieceScene | null>(null);

  useEffect(() => {
    if (!host.current) return;
    const scene = new AllPieceScene(host.current, background);
    sceneRef.current = scene;
    return () => scene.dispose();
  }, [host, background, game]);

  useEffect(() => {
    sceneRef.current?.showGame(game);
  });
}
